export default __webpack_public_path__ + "static/media/uber-eats.0b4839c1.svg";